import React from 'react'
import { TextInput } from 'react-native'
import { useThemeValue } from '../../ThemeContext'
import { baseFont } from '../../utils/ui'

export function ThemedInput({
  style,
  invalid = false,
  ...props
}: React.ComponentProps<typeof TextInput> & {
  invalid?: boolean
}) {
  const { theme } = useThemeValue()

  return (
    <TextInput
      placeholderTextColor={theme.colors.inactive}
      {...props}
      style={[
        {
          ...baseFont('500'),
          width: '100%',
          borderRadius: 16,
          borderWidth: 1,
          borderColor: invalid ? theme.colors.error : theme.colors.border,
          backgroundColor: theme.colors.surface,
          color: theme.colors.text,
          paddingHorizontal: 16,
          paddingVertical: 14,
          fontSize: 16,
        },
        style,
      ]}
    />
  )
}
